import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './venueTypeCapsulePreview.png';
import backPreview from './venueTypeCapsuleBackPreview.png';

export const venueTypeCapsuleDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                This capsule analyses which venue types (Exchange, Dark,
                Alternative) a symbol typically trades in, today&apos;s
                breakdown and your order&apos;s venue type usage.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'venue-type-capsule-chart-preview',
        },
        {
            title: 'Back',
            src: backPreview,
            altText: 'venue-type-capsule-back-preview',
        },
    ],
};
